import * as React from 'react'
import {observer} from 'mobx-react-lite'
import {NumberBulkEditProperty, BulkEditPropertyProps} from './BulkEditDialogProperties'
import {TextField} from '@mui/material'

interface BulkEditNumberControlProps {
    property: BulkEditPropertyProps
    id?: string
}

function _BulkEditNumberControl(props: BulkEditNumberControlProps) {
    const {property, id} = props

    const numberProperty = property as NumberBulkEditProperty

    const [error, setError] = React.useState<boolean>(false)

    const onChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            let value = 0
            try {
                if (!numberProperty.allowFloatingPoint) {
                    value = parseInt(e.target.value)
                } else {
                    value = parseFloat(e.target.value)
                }
            } catch {
                setError(true)
            }

            numberProperty.setValue(isNaN(value) ? 0 : value)
        },
        [numberProperty]
    )

    return <TextField id={id} error={error} type="number" value={numberProperty.value} onChange={onChange} fullWidth />
}

export const BulkEditNumberControl = observer(_BulkEditNumberControl)
